import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { KCP_CERT_STORAGE_KEY, readKcpCertStorage } from '../hooks/useKcpCert';

// Backend KCP callback redirect về /kcp-cert/result?ordrIdxx=...&status=... (chế độ chuyển trang trên mobile)
const KcpCertRedirect = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const { returnPath } = readKcpCertStorage();
        const ordrIdxx = new URLSearchParams(window.location.search).get('ordrIdxx');

        if (ordrIdxx) {
            sessionStorage.setItem(KCP_CERT_STORAGE_KEY, JSON.stringify({ ordrIdxx }));
        } else {
            sessionStorage.removeItem(KCP_CERT_STORAGE_KEY);
        }

        navigate(returnPath || '/padaa010', { replace: true });
    }, [navigate]);

    return null;
};

export default KcpCertRedirect;
